// extracted by mini-css-extract-plugin
export var button = "_fj-4";
export var hasDarkBackground = "_fj-7";
export var hasLightBackground = "_fj-6";
export var iconWrapper = "_fj-0";
export var large = "_fj-2";
export var medium = "_fj-1";
export var small = "_fj-5";
export var xsmall = "_fj-3";